import { post } from './httpUtil';
import { SEND_UI_EVENT } from '../constants/api';
import {
  CALCULATOR_AWAIT,
  ERROR,
  FEEDBACK,
  HOME,
  PAYMENTS,
  THANKS
} from '../constants/routes';

export const onClickWrapper = (identity, handler) => event => {
  const id = identity === null ? event.nativeEvent.target.id : identity;
  post(SEND_UI_EVENT(id, encodeURIComponent(window.location.href)), {}, true);
  if (handler) {
    handler(event);
  }
};

export const hasPayButtonInHeader = (currentRoute, isPaidFully, ignoreHome) => {
  return (
    !isPaidFully &&
    (ignoreHome || currentRoute !== HOME) &&
    currentRoute !== PAYMENTS &&
    currentRoute !== FEEDBACK &&
    currentRoute !== THANKS &&
    currentRoute !== CALCULATOR_AWAIT &&
    currentRoute !== ERROR
  );
};
